































































































import { Intervention } from "../../models/Intervention";
import DateInput from "../../core/Forms/DateInput.vue";
import TimeInput from "../../core/Forms/TimeInput.vue";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import ContactSelect from "../../core/Forms/ContactSelect.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import OptionSelect from "../../core/Forms/OptionSelect.vue";
import { Contact } from "../../models/Contact";
import InputField from "../../core/Forms/InputField.vue";
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";

export default {
    name: "InterventionModalEdit",
    components: {
        CheckboxInput,
        InputField,
        OptionSelect,
        EmployeSelect,
        ContactSelect,
        TextareaInput,
        NumeralInput,
        TimeInput,
        DateInput,
    },
    props: {
        intervention: Intervention,
    },
    data() {
        return {
            EtatOptions: Intervention.Etat,
            EEtat: Intervention.EEtat,
            contactSelectFilters: [
                Contact.EType.Copropriete,
                Contact.EType.Bureau,
                Contact.EType.Particulier,
            ],
        };
    },
    methods: {
        isFinished: function () {
            return (
                this.intervention.etat === Intervention.EEtat.Finished ||
                this.intervention.etat === Intervention.EEtat.Archived
            );
        },
    },
    watch: {
        intervention: {
            handler: function () {
                this.intervention.updateHoraireFin();
            },
            deep: true,
        },
    },
};
